import type { ComponentSchema } from '../../../../../schema-types'

/** Torongo Sign in: phone, SMS code, then a name on the first sign-in. Keys follow lightings-1. */
export const schema: ComponentSchema = {
  type: 'signin',
  label: 'Sign in',
  description: 'Phone number and one-time code card; new shoppers add their name.',
  supportedPages: ['signin', 'forgot-password', 'reset-password'],
  variants: [{ id: 'v1', label: 'Card' }],
  commonFields: [
    { key: 'title', label: 'Title', type: 'localized-string', default: 'Sign in' },
    { key: 'intro', label: 'Intro text', type: 'localized-text', default: 'Use your mobile number. We send you a code by SMS — no password needed.' },
    { key: 'redirectUrl', label: 'Go to after signing in', type: 'string', default: '/account' },
  ],
}
